import { render } from "./DestinationFilter.vue?vue&type=template&id=28b44493&scoped=true"
import script from "./DestinationFilter.vue?vue&type=script&lang=js"
export * from "./DestinationFilter.vue?vue&type=script&lang=js"

import "./DestinationFilter.vue?vue&type=style&index=0&id=28b44493&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b44493"]])

export default __exports__